import React from "react";
import Loader from "react-loader-spinner";
import { LOADER_TYPE } from "global_constants/app_constants";
import { SECONDARY_COLOR } from "global_constants/app_constants";
import PropTypes from "prop-types";
import { PRIMARY_COLOR } from "global_constants/app_constants";
const LoaderHoc = ({ children, isLoading }) => {
  if (isLoading) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
      >
        <Loader
          type={LOADER_TYPE}
          color="#00AEEF"
          width={30}
          height={30}
        />
      </div>
    );
  } else {
    return <>{children}</>;
  }
};

LoaderHoc.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node
};
export default LoaderHoc;